import {Component, Inject, OnInit} from '@angular/core';
import {Question} from '../../../data/models/test/question';
import {QuestionService} from '../../../services/api/question.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-question-delete-dialog',
  templateUrl: './question-delete-dialog.component.html',
  styleUrls: ['./question-delete-dialog.component.css']
})
export class QuestionDeleteDialogComponent implements OnInit {

  testId: number;
  question: Question;

  constructor(
    private questionService: QuestionService,
    public dialogRef: MatDialogRef<QuestionDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      testId: number,
      question: Question,
    },
  ) {
    this.testId = data.testId;
    this.question = data.question;
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
    this.questionService.deleteQuestion(this.testId, this.question.id)
      .then(() => this.dialogRef.close(true));
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
